/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var webix: any;
declare var $$: any;
namespace Nobox.CRM {

    class DealsKanbanFilterOption {
        Search: string;
        //Tags: string;
        Status: string;
        Color: string;
    }
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class DealsKanbanDialog extends NoboxEntityDialog<DealsRow, any> {
        protected getFormKey() { return DealsForm.formKey; }
        protected getIdProperty() { return DealsRow.idProperty; }
        protected getLocalTextPrefix() { return DealsRow.localTextPrefix; }
        protected getService() { return DealsService.baseUrl; }
        protected getDeletePermission() { return DealsRow.deletePermission; }
        protected getInsertPermission() { return DealsRow.insertPermission; }
        protected getUpdatePermission() { return DealsRow.updatePermission; }
        private boardActive: any;
        private kanbanLayout: any;
        private arrBoard: DealpipelinesRow[];
        private arrUser: any[] = null;
        private arrPipelineTypes: any[] = [];
        private userActive: any = null;
        private HeaderList = {};
        private isKontak = false;
        private boardListHapus = [];
        public onBoardRender = () => { };
        private colors_set = [
            { id: 1, value: "Normal", color: "green" },
            { id: 2, value: "Low", color: "orange" },
            { id: 3, value: "Urgent", color: "red" }
        ];
        private idKanban = "kanbanDeals";
        protected form = new DealsForm(this.idPrefix);
        private filterRequest = {
            Search: "",
            Status: "",
            //Tags: "",
            Color: ""
        } as DealsKanbanFilterOption;

        getListBoard() {
            DealpipelinesService.List(
                {
                    Sort: ["Id DESC"],
                    ColumnSelection: 1,
                    IncludeColumns: ["Id", "Nm","Description"]
                },
                res => {
                    if (res.Entities.length != 0) {
                        $$(this.isKontak ?this.idKanban+"btnAddDeal":"btnAddDeal").enable();
                        $$(this.isKontak ?this.idKanban+"btnMenu":"btnMenu").enable();
                        $$(this.isKontak ?this.idKanban+"btnFilterd":"btnFilterd").enable();
                        $$(this.isKontak ?this.idKanban+"search":"search").enable();
                        var arrBoard1 = res.Entities.map(({
                            Id: id,
                            Nm: value,
                            Description: desc,
                            ...rest
                        }) => ({
                            id,
                            value,
                            desc,
                            ...rest
                        })) as any;
                        this.arrBoard = arrBoard1;
                        $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").define("options", arrBoard1);
                        $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").refresh();
                        if (localStorage.getItem(this.isKontak ? this.idKanban + "lastOpenedProject" : "lastOpenedProject") == null) {
                            this.loadData(arrBoard1[0].id, this._ContactId, this._Dealsid, this._GroupId);
                        } else {
                            if (arrBoard1.find(obj => obj.id == localStorage.getItem(this.isKontak ? this.idKanban + "lastOpenedProject" : "lastOpenedProject")) == undefined) {
                                this.loadData(arrBoard1[0].id, this._ContactId, this._Dealsid, this._GroupId);
                            } else {
                                $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").setValue("");
                                $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").setValue(`${localStorage.getItem(this.isKontak ?this.idKanban+"lastOpenedProject":"lastOpenedProject")}`);
                                //this.loadData(localStorage.getItem(this.isKontak ?this.idKanban+"lastOpenedProject":"lastOpenedProject"));
                            }
                        }
                    } else {
                        $$(this.isKontak ?this.idKanban+"btnAddDeal":"btnAddDeal").disable();
                        $$(this.isKontak ?this.idKanban+"btnMenu":"btnMenu").disable();
                        $$(this.isKontak ?this.idKanban+"btnFilterd":"btnFilterd").disable();
                        $$(this.isKontak ?this.idKanban+"search":"search").disable();
                        $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").define("options", [{ "id": "null123", "value": "Add pipeline first", "desc": "" }]);
                        $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").refresh();
                        webix.ui({
                            view: "template", id: this.isKontak ?this.idKanban:"myBoard", template: "<center>Add pipeline first</center>"
                        }, $$(this.isKontak ?this.idKanban:"myBoard"));
                    }
                    this.onBoardRender();
                }
            )
        }

        listBoard() {
            if (this.arrUser == null) {
                TaskService.GetUser(
                    {

                    }, (res:any) => {
                        var userActive = res.find(el => el.displayname == Q.Authorization.userDefinition.DisplayName && el.username == Q.Authorization.userDefinition.Username);
                        if (userActive) {
                            this.userActive = userActive.id;
                        }
                        this.arrUser = res.map(({
                            UserId: id,
                            DisplayName: value,
                            UserImage: UserImage,
                            image = UserImage == null ? null : `${"/upload/" + UserImage}`,
                            ...rest
                        }) => ({
                            id,
                            value,
                            image,
                            ...rest
                        }));
                        this.getListBoard();
                    })
            } else {
                this.getListBoard();
            }
        }

        private _scrollDelay: any;
        CustomAutoScroll() {
            const context = webix.DragControl.getContext();
            const node = webix.DragControl.getNode();
            if (node) {
                const nodePos = webix.html.offset(node);
                const viewPos = webix.html.offset($$(this.isKontak ? this.idKanban+"scroll-kanban":"scroll-kanban").$view);
                const viewPosX = viewPos.x

                const rightNodePos = nodePos.x + nodePos.width;
                const rightViewPos = viewPos.x + viewPos.width;
                const contentWidth = $$(this.isKontak ? this.idKanban+"scroll-kanban":"scroll-kanban").getBody().$width;
                const scrollPosX = $$(this.isKontak ? this.idKanban+"scroll-kanban":"scroll-kanban").getScrollState().x;

                if (this._scrollDelay) {
                    clearTimeout(this._scrollDelay)
                };

                if ((rightNodePos > rightViewPos) && (viewPos.width + scrollPosX < contentWidth)) {
                    $$(this.isKontak ? this.idKanban+"scroll-kanban":"scroll-kanban").scrollTo(scrollPosX + 30);
                    this._scrollDelay = setTimeout(() => this.CustomAutoScroll(), 50);
                } else if ((nodePos.x < viewPos.x) && (scrollPosX > 0)) {
                    $$(this.isKontak ? this.idKanban+"scroll-kanban":"scroll-kanban").scrollTo(scrollPosX > 10 ? scrollPosX - 30 : 0);
                    this._scrollDelay = setTimeout(() => this.CustomAutoScroll(), 50);
                }
            };
        }

        mappingHeader(item: DealpipelinetypesRow[]) {
            var arrHeader = [];
            var timezone = "";
            if (this.getCookie("timezone") == undefined || this.getCookie("timezone") == "" || this.getCookie("timezone") == null) {
                timezone = "Asia/Jakarta";
            } else {
                timezone = this.getCookie("timezone").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%2C", 'g'), ",");
            }
            var $this = this;
            this.arrPipelineTypes = [];
            this.HeaderList = {};
            item.forEach(x => {
                this.HeaderList[x.Name] = x.Id;
                this.arrPipelineTypes.push(x);
                arrHeader.push({
                    width: 300,
                    rows: [
                        {
                            view: "kanbanheader", type: "sub", label: x.Name, link: `${x.Id}`, on: {
                                onBeforeCardAdd(obj, list) {
                                    //obj.tags = [];
                                    obj.type = 'deal';
                                    obj.CryId = $.cookie('currencies') == undefined ? "Rp" : $.cookie('currencies');
                                    obj.Prc = `0`;
                                    obj.color = "1";
                                    obj.piplinetypes = x.Id;
                                    obj.pipelineId = $this.boardActive;
                                    obj.contacts = $this.contactId != null ? [{ "CtId": $this.contactId }]:null,
                                    obj.deal = $this.dealsId;
                                    obj.start_date = Q.formatDate(moment().tz(timezone).toDate(), "yyyy-MM-dd HH:mm:ss");
                                    obj.end_date = Q.formatDate(moment().add(-2, "d").tz(timezone).toDate(), "yyyy-MM-dd HH:mm:ss");
                                    obj.group = $this.groupId;
                                    obj.text = `New ${x.Name} Deal`;
                                    var index = 0;
                                    $$(this.isKontak ? this.idKanban : "myBoard").serialize().forEach(c => {
                                        if (c.piplinetypes == x.Id && c.text == obj.text) {
                                            index++;
                                        } else if (c.piplinetypes == x.Id && c.text == obj.text + ` (${index})`) {
                                            index++;
                                        }
                                    })
                                    if (index != 0) {
                                        obj.text = obj.text + ` (${index})`;
                                    }
                                    obj.write_date = Q.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
                                }
                            },
                        },
                        { id: `${x.Id}`, view: "kanbanlist", status: x.Name, type: "cards" }
                    ]
                });
            });
            return arrHeader;
        }
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts[1] == undefined) {
                if (name == "formatdate") {
                    return "DD-MM-YYYY";
                } else if (name == "formattime") {
                    return "HH:mm";
                } else if (name == "timezone") {
                    return "Asia/Jakarta";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }
        getKeyByValue(object, value) {
            for (const key in object) {
                if (object[key] === value) {
                    return key;
                }
            }
            // If the value is not found, you can return a default value or null.
            return "";
        }
        mappingItem(item: DealsRow[]) {
            var arrItem = [];
            var timezone = "";
            if (this.getCookie("timezone") == undefined || this.getCookie("timezone") == "" || this.getCookie("timezone") == null) {
                timezone = "Asia/Jakarta";
            } else {
                timezone = this.getCookie("timezone").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%2C", 'g'), ",");
            }
            item.forEach(x => {
                var namaStatus = this.getKeyByValue(this.HeaderList, x.piplinetypes);
                arrItem.push({
                    "type": 'deal',
                    "id": x.Id,
                    "text": x.Nm,
                    "text2": '<br>' + x.CryId + x.Prc,
                    "CryId": x.CryId,
                    "Prc": x.Prc,
                    "groups": x.GrpId,
                    "Pdt": x.Pdt,
                    "products": x.PdtIds,
                    "contacts": x.CtDeal,
                    "Src": x.Src,
                    "start_date": x.StDt,
                    "end_date": x.ClsDt,
                    "$index": x.Index,
                    //"tags": x.Tags == "" || x.Tags == null ? [] : x.Tags.split(","),
                    "user_id": x.Assign,
                    "color": x.PriorityId,
                    //${moment(x.write_date).tz($.cookie('timezone')).format($.cookie('formatdate') + ', '+ $.cookie('formattime'))}
                    "write_date": x.Up,
                    "create_date": x.In,
                    "Attachment": [], //JSON.parse(x.Attachment),
                    "status": namaStatus,
                    "rId": x.Id,
                    "piplinetypes": x.piplinetypes,
                    "pipelineId": x.PlId,
                    "comments": x.Comments.map(c => ({ id: c.Id, user_id: c.UserId, date: moment(c.WriteDate).tz(timezone).toDate(), text: c.Comment }))
                });
            });
            return arrItem;
        }

        renderKanban(arrHeader, arrItem) {
            const images = { jpg: true, jpeg: true, png: true, gif: true };
            function isImage(key) {
                return images[key.toString().toLowerCase()];
            }
            var $this = this;
            if ($$(this.isKontak ?this.idKanban:"myBoard").P.view != "template") {
                $$(this.isKontak ?this.idKanban:"myBoard").clearAll();
            }
            if (arrHeader.length == 0) {
                $$(this.isKontak ?this.idKanban+"btnAddDeal":"btnAddDeal").disable();
                $$(this.isKontak ?this.idKanban+"btnFilterd":"btnFilterd").disable();
                $$(this.isKontak ?this.idKanban+"search":"search").disable();
                $$(this.isKontak ?this.idKanban+"scroll-kanban":"scroll-kanban").show();
                webix.ui({
                    view: "template", id: this.isKontak ?this.idKanban:"myBoard", template: "<center>Add pipeline list first</center>"
                }, $$(this.isKontak ?this.idKanban:"myBoard"));
            } else {
                $$(this.isKontak ?this.idKanban+"btnAddDeal":"btnAddDeal").enable();
                $$(this.isKontak ?this.idKanban+"btnFilterd":"btnFilterd").enable();
                $$(this.isKontak ?this.idKanban+"search":"search").enable();
                webix.ui({
                    view: "kanban", id: this.isKontak ?this.idKanban:"myBoard",
                    cols: arrHeader,
                    isKontak: this.isKontak,
                    idKanban: this.idKanban,
                    on: {
                        onBeforeStatusChange(itemId, status, list) {
                            var item = this.getItem(itemId);
                            var statusOld = item.status;
                            var comments = item.comments == null ? [] : item.comments;
                            comments.push({
                                date: new Date(),
                                id: webix.uid(),
                                text: `dipindahkan dari ${statusOld} ke ${status}`,
                                user_id: $this.userActive
                            });
                            item.comments = comments;
                            //$$(this.isKontak ?this.idKanban:"myBoard").updateItem(item.id, item)
                        },
                        onListBeforeDragIn(context, e, list) {
                            $this.CustomAutoScroll.call($this);
                        },
                        onListDragOut() {
                            $this.CustomAutoScroll.call($this);
                        },
                        //onAfterEditorShow: (editor, obj) => {
                        //    editor._header.setValue("Add Deal")
                        //    editor._header.data.label = "Deal";
                        //    editor._removeBtn.setValue("Delete")
                        //    editor._removeBtn.data.label = "Delete";
                        //    editor._header.refresh();
                        //    editor._removeBtn.refresh();
                        //},
                        onListItemDblClick: function (id, e, node, list) {
                            var dlg = new DealsDialog();
                            dlg.callbackSave = (res) => {
                                $this.editDeal(res);
                            }
                            dlg.callbackDelete = (res) => {
                                $this.deleteDeal(res);
                            }
                            if ($(document).width() < 576) {
                                dlg.loadByIdAndOpenDialog(id, true);
                            } else {
                                dlg.loadByIdAndOpenDialog(id);
                            }
                        },
                        onListItemClick: function (id, e, node, list) {
                            if (e.target.className != "webix_kanban_footer_icon" && e.target.className != "webix_kanban_icon kbi-cogs webix_icon" && e.target.className != "webix_kanban_icon kbi-comment webix_icon" && e.target.className != "webix_kanban_icon_text") {
                                var dlg = new DealsDialog();
                                dlg.callbackSave = (res) => {
                                    $this.editDeal(res);
                                }
                                dlg.callbackDelete = (res) => {
                                    $this.deleteDeal(res);
                                }
                                if ($(document).width() < 576) {
                                    dlg.loadByIdAndOpenDialog(id, true);
                                } else {
                                    dlg.loadByIdAndOpenDialog(id);
                                }
                            }
                        },
                        onBeforeCardAction: function (action, id) {
                            if (action === "edit") {
                                var dlg = new DealsDialog();
                                dlg.callbackSave = (res) => {
                                    $this.editDeal(res);
                                }
                                dlg.callbackDelete = (res) => {
                                    $this.deleteDeal(res);
                                }
                                if ($(document).width() < 576) {
                                    dlg.loadByIdAndOpenDialog(id, true);
                                } else {
                                    dlg.loadByIdAndOpenDialog(id);
                                }
                            }
                        },
                    },
                    attachments: "/attachments",
                    comments: { currentUser: $this.userActive, mentions: true, id: "comments", name: "comments" },
                    data: arrItem,
                    cardActions: [
                        "edit", "copy", "remove",
                    ],
                    users: $this.arrUser,
                    colors: $this.colors_set,
                    save: function (id, operation, update) {
                        var idItem = $$($this.isKontak ? $this.idKanban:"myBoard").getItem(id);
                        var elItem = $(`.webix_list_item.webix_kanban_list_item[webix_l_id='${id}'] .webix_kanban_body`);
                        var lastUpdate = Q.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
                        if (operation == "update") {
                            var comments = update.comments == null ? [] : update.comments.map(c => ({ Id: webix.uid(), UserId: c.user_id, WriteDate: c.date, Comment: c.text }));
                            if ($this.HeaderList[update.status] != undefined) {
                                DealsService.Update({
                                    EntityId: id,
                                    Entity: {
                                        Nm: update.text,
                                        CryId: update.CryId,
                                        Prc: update.Prc,
                                        GrpId: update.groups,
                                        Pdt: update.Pdt,
                                        PdtIds: update.products,
                                        CtDeal: update.contacts,
                                        Src: update.Src,
                                        Index: idItem.$index,
                                        StDt: update.start_date,
                                        ClsDt: update.end_date,
                                        Assign: update.user_id,
                                        PriorityId: update.color,
                                        Comments: comments,
                                        piplinetypes: $this.HeaderList[update.status],
                                        PlId: update.pipelineId
                                    }
                                }, (res) => {
                                    $this.kanbanLayout.adjust();
                                }, {
                                    onError: (err) => {
                                    }
                                });
                            } else {

                            }
                        }

                        if (operation == "insert") {
                            DealsService.Create({
                                Entity: {
                                    Id:id,
                                    Nm: update.text,
                                    CryId: update.CryId,
                                    Prc: update.Prc,
                                    GrpId: update.groups,
                                    Index: idItem.$index,
                                    Pdt: update.Pdt,
                                    PdtIds: update.products,
                                    CtDeal: update.contacts,
                                    Src: update.Src,
                                    StDt: update.start_date,
                                    ClsDt: update.end_date,
                                    Assign: update.user_id,
                                    PriorityId: update.color,
                                    piplinetypes: update.piplinetypes,
                                    PlId: update.pipelineId
                                }
                            }, (res) => {
                                $this.kanbanLayout.adjust();
                            });
                        }
                        if (operation == "delete") {
                            DealsService.Delete({
                                EntityId: id
                            }, (res) => {
                            });
                        }
                    }
                }, $$(this.isKontak ?this.idKanban:"myBoard"));
            }
        }

        public refreshSize() {
            this.kanbanLayout.adjust();
        }

        loadData(boardId,contact=null,dealid=null,groupid=null) {
            this.boardActive = boardId;
            if (this.timerActive) {
                this.onTimesUp($(".btn-auto-refresh").find(".button-inner"), "...");
            }
            Q.serviceCall({
                url: "/Services/" + DealsService.baseUrl + "/KanbanData",
                blockUI: false,
                request: {
                    EqualityFilter: {
                        project_id: boardId,
                        KontakId: contact,
                        //DealId: dealid,
                        //GroupId: groupid
                    },
                    Sort: ["Urutan ASC"]
                },
                onSuccess: (res: DealsKanbanResponse) => {
                    this.renderKanban(this.mappingHeader(res.ArrHeader), this.mappingItem(res.ArrItem));
                    if (this.timerActive) {
                        this.element.find(".btn-auto-refresh").find(".button-inner").text("10");
                        this.startTimer(this.element.find(".btn-auto-refresh").find(".button-inner"));
                    }
                    if ($$(this.isKontak ? this.idKanban +'btn-listd':'btn-listd').getValue() == 1) {
                        $$(this.isKontak ?this.idKanban+"vlist":"vlist").clearAll(); $$(this.isKontak ?this.idKanban+"vlist":"vlist").parse($$(this.isKontak ?this.idKanban:"myBoard").serialize(), "json");
                    }
                }
            });
        }

        addDeal(res: DealsRow) {
            var item = {
                "id": webix.uid(),
                "text": res.Nm,
                "text2": '<br>' + res.CryId + res.Prc,
                "CryId": res.CryId,
                "Prc": res.Prc,
                "groups": res.GrpId,
                "Pdt": res.Pdt,
                "products": res.PdtIds,
                "contacts": res.CtDeal,
                "Src": res.Src,
                "start_date": res.StDt,
                "end_date": res.ClsDt,
                "user_id": res.Assign,
                "color": res.PriorityId,
                "write_date": res.Up,
                "create_date": res.In,
                "Attachment": [], //JSON.parse(res.Attachment),
                "rId": res.Id,
                "piplinetypes": res.piplinetypes,
                "pipelineId": res.PlId
            };
            $$(this.isKontak ?this.idKanban:"myBoard").add(item);
        }

        editDeal(res: DealsRow) {
            var item = {
                "id": res.Id,
                "text": res.Nm,
                "text2": '<br>' + res.CryId + res.Prc,
                "CryId": res.CryId,
                "Prc": res.Prc,
                "groups": res.GrpId,
                "Pdt": res.Pdt,
                "products": res.PdtIds,
                "contacts": res.CtDeal,
                "Src": res.Src,
                "start_date": res.StDt,
                "end_date": res.ClsDt,
                "user_id": res.Assign,
                "color": res.PriorityId,
                "write_date": res.Up,
                "create_date": res.In,
                "Attachment": [], //JSON.parse(res.Attachment),
                "rId": res.Id,
                "piplinetypes": res.piplinetypes,
                "pipelineId": res.PlId
            };
            if (res.PlId != this.boardActive) {
                $$(this.isKontak ? this.idKanban : "myBoard").remove(res.Id);
                delete res.Id;
                DealsService.Create(
                    {
                        Entity: res
                    }, (result) => {
                    });
            } else {
                $$(this.isKontak ? this.idKanban : "myBoard").updateItem(res.Id, item)
            }
        }

        deleteDeal(id: any) {
            $$(this.isKontak ?this.idKanban:"myBoard").remove(id);
        }

        initKanbanBody() {
            var $this = this;
            var arr = [
                {
                    scroll: "x",
                    view: "scrollview",
                    id: $this.isKontak ? $this.idKanban+"scroll-kanban":"scroll-kanban",
                    height: parseFloat($("section.content").css("min-height").replace("px", "")) - 180,
                    body: {
                        view: "kanban", id: $this.isKontak ? $this.idKanban:"myBoard",
                        cols: [],
                        users: this.arrUser,
                        comments: { currentUser: 9 },
                        data: [],
                        //tags: [],
                        cardActions: [
                            //default
                            "edit", "copy", "remove",
                        ],
                        save: function (id, operation, update) {
                        }
                    }
                },
                {
                    hidden: true,
                    height: parseFloat($("section.content").css("min-height").replace("px", "")) - 180,
                    id: $this.isKontak ? $this.idKanban+"vlist":"vlist",
                    view: "datatable",
                    sort: true,
                    dragscroll: true,
                    dragColumn: true,
                    drag: true,
                    columns: [
                        {
                            id: "user_id", header: "Assign", css: "Assign", template: function (obj) {
                                var i = $this.arrUser.map(function (e) { return e.id }).indexOf(parseInt(obj.user_id));
                                if (i == -1) {
                                    return `<div1 style="margin-bottom:5px;margin-right:2px;display: inline-block;" title="no assign user" class="avatar text-center bg-light"><span class="webix_icon webix_kanban_icon kbi-account"></span></div1>No Assign User`
                                } else {
                                    if ($this.arrUser[i].image != undefined) {
                                        return `<img class="avatar" title="${$this.arrUser[i].value}" src="${$this.arrUser[i].image}" style="margin-bottom:5px;margin-right:2px;">${$this.arrUser[i].value}`
                                    } else {
                                        return `<div1 style="margin-bottom:5px;margin-right:2px;display: inline-block;" title="${$this.arrUser[i].value}" class="avatar text-center bg-light"><span class="webix_icon webix_kanban_icon kbi-account"></span></div1>${$this.arrUser[i].value}`
                                    }
                                }
                            }, fillspace: 1.5, sort: "string"
                        },
                        { id: "text", header: "Deal Name", template: "<strong>#text#</strong>", fillspace: 2.5, sort: "string" },
                        { id: "status", header: "Stage (List)", fillspace: 1, sort: "string" },
                        {
                            id: "Prc", header: "Price", fillspace: 1, template: function (obj) {
                                if (obj.Prc != undefined) {
                                    var format = $this.formatAutoNumeric(obj.Prc);
                                    return `${obj.CryId} ${format}`;
                                } else {
                                    return `${obj.CryId} 0`;
                                }
                            }, sort: "string"
                        },
                        { id: "Pdt", header: "Product", fillspace: 1, sort: "string" },
                        {
                            id: "start_date", header: "Start Date", fillspace: 1.5, template: function (obj) {
                                var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                var stringTgl = format(new Date(obj.start_date));
                                if (obj.start_date == null || obj.start_date == undefined || obj.start_date == "") {
                                    return "Start Date Not Set";
                                } else {
                                    return stringTgl;
                                }
                            }, sort: "string"
                        },
                        {
                            id: "end_date", header: "End Date", fillspace: 1.5, template: function (obj) {
                                var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                var stringTgl = format(new Date(obj.end_date));
                                if (obj.end_date == null || obj.end_date == undefined || obj.end_date == "") {
                                    return "End Date Not Set";
                                } else {
                                    return stringTgl;
                                }
                            }, sort: "string"
                        },
                        {
                            id: "write_date", header: "Last Update", fillspace: 1.5, template: function (obj) {
                                var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                var stringTgl = format(new Date(obj.write_date));
                                return stringTgl;
                            }, sort: "string"
                        }
                    ],
                    resizeColumn: true,
                    on: {
                        "onItemClick": function (id, e, trg) {
                            var dlg = new DealsDialog();
                            dlg.callbackSave = (res) => {
                                $this.editDeal(res);
                                $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                            }
                            dlg.callbackDelete = (res) => {
                                $this.deleteDeal(res);
                                $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                            }
                            dlg.loadByIdAndOpenDialog(id.row);
                        }
                    }
                }
            ] as any[];

            if ($(document).width() < 576) {
                arr.unshift(
                    {
                        view: "toolbar", id: $this.isKontak ? $this.idKanban + "tlbr2d":"tlbr2d", cols: [
                            { id: $this.isKontak ? $this.idKanban + "btn-kanband":"btn-kanband", view: "toggle", type: "iconTop", icon: "mdi mdi-music", label: "Board", value: true },
                            { id: $this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd', view: "toggle", type: "iconTop", icon: "mdi mdi-microphone", label: "List" }
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: $this.isKontak ? $this.idKanban + "tlbr2d" : "tlbr2d", cols: [
                            {
                                view: "button",
                                type: "icon",
                                id: $this.isKontak ? $this.idKanban+"btnFilterd":"btnFilterd",
                                width: 50,
                                icon: "wxi-filter",
                                label: "",
                                click: function () {
                                    $this.showForm("win1d", this.$view);
                                    $$($this.isKontak ? $this.idKanban + "filter-statusd":"filter-statusd").define("options", {
                                        data: $$($this.isKontak ? $this.idKanban:"myBoard").getStatuses(),
                                        selectAll: true
                                    });
                                    $$($this.isKontak ? $this.idKanban + "filter-statusd" : "filter-statusd").refresh();
                                    $$($this.isKontak ? $this.idKanban + "filterFormd":"filterFormd").setValues({
                                        //tags: $this.filterRequest.Tags,
                                        status: $this.filterRequest.Status,
                                        color: $this.filterRequest.Color,
                                    });
                                }
                            },
                            { view: "search", align: "center", placeholder: "Cari..", id: $this.isKontak ? $this.idKanban+"search":"search", width: "auto" },
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr12", cols: [
                            {
                                view: "button", id: $this.isKontak ? $this.idKanban + "btnAddBoard" : "btnAddBoard", label: "Pipeline", type: "icon", icon: "wxi-plus", click: () => {
                                    this.element.find('#addBoardPopup').lkmodal('show');
                                }
                            },
                            {
                                view: "button", id: $this.isKontak ? $this.idKanban + "btnAddDeal" : "btnAddDeal", label: "Deal", type: "icon", icon: "wxi-plus", click: function () {
                                    var dlg = new DealsDialog();
                                    dlg.callbackSave = (res) => {
                                        $this.addDeal(res);
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd').getValue() == 1) {
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                                        }
                                    }
                                    dlg.callbackDelete = (res) => {
                                        $this.deleteDeal(res);
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd').getValue() == 1) {
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                                        }
                                    }
                                    dlg.loadEntityAndOpenDialog({
                                        PlId: $this.boardActive,
                                        //KontakId: $this.contactId,
                                        //DealId: $this.dealsId,
                                        GrpId: $this.groupId
                                    }, true);
                                }
                            }
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr1", cols: [
                            {
                                view: "select",
                                label: "",
                                labelAlign: "center",
                                id: $this.isKontak ? $this.idKanban+"selectBoard":"selectBoard",
                                width: "auto",
                                value: 1, options: [{ "id": "null123", "value": "Add pipeline first", "desc": "" }]
                            },
                            {
                                view: "button", id: $this.isKontak ? $this.idKanban+"btnMenu":"btnMenu", label: "", type: "icon", icon: "wxi-dots", width: 50, click: function () {
                                    $this.showForm("win2d", this.$view);
                                    var ab = $this.arrBoard.find(obj => obj.id == $this.boardActive)
                                    $$($this.isKontak ? $this.idKanban + "menuFormd" : "menuFormd").setValues({
                                        id: ab.id,
                                        name: ab.value,
                                        desc: ab.desc
                                    })
                                }
                            }
                        ]
                    });
            } else {
                arr.unshift(
                    {
                        view: "toolbar", id: $this.isKontak ? $this.idKanban + "tlbr2d" : "tlbr2d", cols: [
                            {
                                view: "button",
                                id: $this.isKontak ? $this.idKanban+"btnFilterd":"btnFilterd",
                                width: 100, value: 'Filter',
                                click: function () {
                                    $this.showForm("win1d", this.$view);
                                    $$($this.isKontak ? $this.idKanban + "filter-statusd" : "filter-statusd").define("options", {
                                        data: $$($this.isKontak ? $this.idKanban:"myBoard").getStatuses(),
                                        selectAll: true
                                    });
                                    $$($this.isKontak ? $this.idKanban + "filter-statusd" : "filter-statusd").refresh();
                                }
                            },
                            { view: "search", align: "center", placeholder: "Cari..", id: $this.isKontak ? $this.idKanban+"search":"search", width: 300 },
                            {},
                            { id: $this.isKontak ? $this.idKanban + "btn-kanband":"btn-kanband", autowidth: true, minWidth: 80, view: "toggle", type: "iconTop", icon: "mdi mdi-music", label: "Kanban", value: true },
                            { id: $this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd', autowidth: true, view: "toggle", type: "iconTop", icon: "mdi mdi-microphone", label: "List" }
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr1", cols: [
                            {
                                view: "select",
                                label: "Pipeline",
                                labelAlign: "center",
                                id: $this.isKontak ? $this.idKanban+"selectBoard":"selectBoard",
                                width: 300,
                                value: 1, options: [{ "id": "null123", "value": "Add pipeline first", "desc": "" }]
                            },
                            {},
                            {
                                view: "button", id: $this.isKontak ? $this.idKanban + "btnAddBoard" : "btnAddBoard", label: "Pipeline", type: "icon", icon: "wxi-plus", width: 120, click: () => {
                                    this.element.find('#addBoardPopup').lkmodal('show');
                                }
                            },
                            {
                                view: "button", id: $this.isKontak ? $this.idKanban + "btnAddDeal" : "btnAddDeal", label: "Deal", type: "icon", icon: "wxi-plus", width: 120, click: function () {
                                    var dlg = new DealsDialog();
                                    dlg.callbackSave = (res) => {
                                        $this.addDeal(res);
                                    }
                                    dlg.callbackDelete = (res) => {
                                        $this.deleteDeal(res);
                                    }
                                    dlg.loadEntityAndOpenDialog({
                                        PlId: $this.boardActive,
                                        //KontakId: $this.contactId,
                                        GrpId: $this.groupId
                                    });
                                }
                            },
                            {
                                view: "button", id: $this.isKontak ? $this.idKanban+"btnMenu":"btnMenu", label: "", type: "icon", icon: "wxi-dots", width: 50, click: function () {
                                    $this.showForm("win2d", this.$view);
                                    var ab = $this.arrBoard.find(obj => obj.id == $this.boardActive)
                                    $$($this.isKontak ? $this.idKanban + "menuFormd" : "menuFormd").setValues({
                                        id: ab.id,
                                        name: ab.value,
                                        desc: ab.desc
                                    })
                                }
                            }
                        ]
                    });
            }
            return arr;
        }
        initKanban() {
            var $this = this;
            const images = { jpg: true, jpeg: true, png: true, gif: true };
            function isImage(key) {
                return images[key.toString().toLowerCase()];
            }
            webix.type(webix.ui.kanbanlist, {
                name: "cards",
                templateAvatar: function (t, e, i) {
                    if (t.type == "task") {
                        if (Q.isEmptyOrNull(t.contacts)) {
                            return `<span class="webix_icon webix_kanban_icon kbi-account" title=""></span>`;
                        } else {
                            if (!Q.isEmptyOrNull(t.foto)) {
                                return `<img class="avatar" style="max-width: 100%;max-height: 100%;" src="${t.foto}" title="${t.nama}" />`;
                            } else {
                                return `<span class="webix_icon webix_kanban_icon kbi-account" title="${t.nama}"></span>`;
                            }
                        }
                    } else {
                        var n = i._users,
                            a = t.user_id && n.exists(t.user_id) ? n.getItem(t.user_id) : {};
                        return a.image ? "<img class='webix_kanban_avatar' src='" + a.image + "' title='" + (a.value || "") + "'>" : "<span class='webix_icon webix_kanban_icon kbi-account' title='" + (a.value || "") + "'></span>";
                    }
                },
                templateAttachments: function (obj) {
                    let html = "";
                    if (webix.isArray(obj.attachments)) {
                        for (let i in obj.attachments) {
                            let v = obj.attachments[i];
                            let type = (typeof v.Filename === "string" && v.Filename) ? v.Filename.split(".").pop() : "";
                            if (isImage(type)) {
                                html += "<img class='webix_kanban_attachment' src='/upload/" + v.Filename + "'/>";
                                break;
                            }
                        }
                    }
                    return html;
                },
                templateBody(obj) {
                    if (obj.type == "deal") {
                        const html = `
                                      <div>${obj.text}</div>
                                      <div class="lkbadge lkbadge-secondary lkbadge-dim tresury">${obj.CryId} ${$this.formatAutoNumeric(obj.Prc)}</div>
                                      <hr class="solid">
                                      <div class="small text-muted">Created: ${moment(obj.create_date).tz($.cookie('timezone')).format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}</div>
                                      <div class="small text-muted">Modified: ${moment(obj.write_date).tz($.cookie('timezone')).format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}</div>
                                      `;

                        return html;
                    } else {
                        var startEl = "";
                        var endEl = "";
                        var finalEl = "";
                        if (obj.start_date != null) {
                            var momentDate = moment(obj.start_date).tz($.cookie('timezone'));
                            var momentDateNow = moment().tz($.cookie('timezone'));
                            if (momentDate.format("YYYY") == momentDateNow.format("YYYY")) {
                                if (momentDate.format("DD") == momentDateNow.format("DD")) {
                                    startEl = `<span class="fw-bold">today</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else if (moment().tz($.cookie('timezone')).add(1, "d").format("DD") == momentDate.format("DD")) {
                                    startEl = `<span class="fw-bold">tomorrow</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else {
                                    startEl = `<span class="fw-bold">${momentDate.format("MMM DD")}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                }
                            } else {
                                startEl = `<span class="fw-bold">${momentDate.format($.cookie('formatdate'))}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                            }
                        }
                        if (obj.end_date != null) {
                            var momentDate = moment(obj.end_date).tz($.cookie('timezone'));
                            var momentDateNow = moment().tz($.cookie('timezone'));
                            if (momentDate.format("YYYY") == momentDateNow.format("YYYY")) {
                                if (momentDate.format("DD") == momentDateNow.format("DD")) {
                                    endEl = `<span class="fw-bold">today</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else if (moment().tz($.cookie('timezone')).add(1, "d").format("DD") == momentDate.format("DD")) {
                                    endEl = `<span class="fw-bold">tomorrow</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else {
                                    endEl = `<span class="fw-bold">${momentDate.format("MMM DD")}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                }
                            } else {
                                endEl = `<span class="fw-bold">${momentDate.format($.cookie('formatdate'))}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                            }
                        }
                        if (startEl != "" && endEl != "") {
                            var startDate = moment(obj.start_date).tz($.cookie('timezone'));
                            var endDate = moment(obj.end_date).tz($.cookie('timezone'));
                            const durationInMilliseconds = endDate.diff(startDate);
                            const duration = moment.duration(durationInMilliseconds);
                            const days = duration.days();
                            const hours = duration.hours();
                            const minutes = duration.minutes();
                            var durEl = "";
                            if (days != 0 && hours != 0 && minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days, ${hours}.${minutes} Hours</div>`;
                            } else if (days != 0 && minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days, ${minutes} Minutes</div>`;
                            } else if (days != 0 && hours != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days, ${hours} Hours</div>`;
                            } else if (hours != 0 && minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${hours}.${minutes} Hours</div>`;
                            } else if (days != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days</div>`;
                            } else if (hours != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${hours} Hours"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${hours} Hours</div>`;
                            } else if (minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${minutes} Minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${minutes} Minutes</div>`;
                            }
                            if (startEl.split(",")[0] == endEl.split(",")[0]) {
                                finalEl = `<div class="small text-muted" title="Task start at ${startDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))} end in ${endDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">${startEl} -${endEl.split(",")[1]}</div>${durEl}`;
                            } else {
                                finalEl = `<div class="small text-muted" title="Task start at ${startDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))} end in ${endDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">${startEl} - ${endEl}</div>${durEl}`;
                            }
                        } else if (startEl != "") {
                            var startDate = moment(obj.start_date).tz($.cookie('timezone'));
                            finalEl = `<hr class="solid"><div class="small text-muted" title="Task start at ${startDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">Start ${startEl}</div>`;
                        } else if (endEl != "") {
                            var endDate = moment(obj.end_date).tz($.cookie('timezone'));
                            finalEl = `<hr class="solid"><div class="small text-muted" title="Task end at ${endDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">End ${endEl}</div>`;
                        }

                        return `<div>${obj.text}</div>
                                ${finalEl}`;
                    }
                }
            });
            this.kanbanLayout = webix.ui({
                id: "layoutKanban",
                container: $this.isKontak ? $this.idKanban : "kanban",
                rows: $this.initKanbanBody()
            });
            $$(this.isKontak ?this.idKanban+"search":"search").attachEvent("onTimedKeyPress", function () {
                //get user input value
                var value = this.getValue().toLowerCase();
                $this.filterRequest.Search = value;
                $this.handlerFilter();
            });
            this.popupMenu();
            $$($this.isKontak ? $this.idKanban + "btn-kanband":"btn-kanband").attachEvent("onItemClick", function (id, e) {
                $$($this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd').setValue(0);
                $$($this.isKontak ? $this.idKanban + "scroll-kanban" : "scroll-kanban").show();
                $$($this.isKontak ? $this.idKanban+"vlist":"vlist").hide();
            });
            $$($this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd').attachEvent("onItemClick", function (id, e) {
                $$('btn-kanband').setValue(0);
                $$($this.isKontak ? $this.idKanban+"scroll-kanban":"scroll-kanban").hide();
                $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                $$($this.isKontak ? $this.idKanban+"vlist":"vlist").show();
                $$("layoutKanban").resize();
            });
        }

        popupMenu() {
            var $this = this;
            webix.ui({
                view: "popup",
                id: "win2d",
                width: 300,
                head: false,
                body: {
                    view: "form",
                    id: $this.isKontak ? $this.idKanban + "menuFormd" : "menuFormd",
                    borderless: true,
                    elements: [
                        //{ view: "label", label: "Nama Project", autowidth: true, align: "left" },
                        //{
                        //    view: "template",
                        //    template: `<div class="p-2 ">Erik Setiadi</div>`,
                        //    id: "board-name-menu",
                        //    autowidth: true,
                        //},
                        { view: "text", label: 'Pipeline Name', css: "board-name-menu", name: "name", readonly: true, borderless: true, disabled: true },
                        {
                            view: "textarea",
                            label: 'Description',
                            css: "board-desc-menu",
                            height: 150,
                            name: "desc",
                            readonly: true,
                            disabled: true
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: "Edit", click: () => {
                                        $$("win2d").hide();
                                        //$('#editBoardPopup').lkmodal('show');
                                        //boardEditAmbilValue();
                                        $this.element.find('#editBoardPopup').lkmodal('show');
                                        $this.boardEditAmbilValue();
                                    }
                                },
                                {
                                    view: "button", value: "Delete", click: function () {
                                        webix.confirm({
                                            title: "Are you sure you want to delete this pipeline?",
                                            ok: "Yes", cancel: "No",
                                            text: "Data in this pipeline will be delete permanent"
                                        })
                                            .then(function () {
                                                DealpipelinesService.Delete(
                                                    {
                                                        EntityId: $this.boardActive,
                                                    },
                                                    res => {
                                                        $$("win2d").hide();
                                                        $this.listBoard();
                                                    }
                                                )
                                            });
                                    }
                                }
                            ],
                        }
                    ],
                    elementsConfig: {
                        labelPosition: "top",
                    }
                }
            });

            webix.ui({
                view: "popup",
                id: "win1d",
                width: 300,
                css: "popupfilter",
                head: false,
                body: {
                    view: "form",
                    id: $this.isKontak ? $this.idKanban + "filterFormd" : "filterFormd",
                    borderless: true,
                    elements: [
                        //{ view: "text", label: 'Title', name: "text", id: "filter-text" },
                        //{
                        //    view: "multiselect",
                        //    label: 'Tags',
                        //    name: "tags",
                        //    id: "filter-tags",
                        //    options: {
                        //        data: [],
                        //        selectAll: truefilter-status
                        //    }
                        //},
                        {
                            view: "multiselect",
                            label: 'Status',
                            name: "status",
                            id: $this.isKontak ? $this.idKanban + "filter-statusd" : "filter-statusd",
                            options: {
                                data: [],
                                selectAll: true
                            }
                        },
                        //{
                        //    view: "multiselect",
                        //    label: 'Assign To',
                        //    name: "assign",
                        //    id: "filter-assign",
                        //    options: {
                        //        data: [],
                        //        selectAll: true
                        //    }
                        //},
                        {
                            view: "multiselect",
                            label: 'Priority',
                            name: "color",
                            id: "filter-colord",
                            options: {
                                data: [
                                    { id: "#005FB1", value: "None" },
                                    { id: "green", value: "Low" },
                                    { id: "orange", value: "Medium" },
                                    { id: "red", value: "High" }
                                ],
                                selectAll: true
                            }
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: "Reset", click: function () {
                                        $$($this.isKontak ? $this.idKanban : "myBoard").filter();
                                        $this.filterRequest.Search = "";
                                        //$this.filterRequest.Tags = "";
                                        $this.filterRequest.Status = "";
                                        $this.filterRequest.Color = "";
                                        //var arrWritedate = $$(this.isKontak ?this.idKanban:"myBoard").serialize();
                                        //arrWritedate.forEach(function (e) {
                                        //    $(`.webix_list_item.webix_kanban_list_item[webix_l_id='${e.id}'] .webix_kanban_body`).append(`<div class="webix_card_last_update small text-muted">${$.timeago(new Date(e.write_date))}</div>`);
                                        //})
                                        //ftext = "";
                                        //ftags = "";
                                        //fstatus = "";
                                        //fassign = "";
                                        //fcolor = "";
                                        this.getTopParentView().hide();
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd').getValue() == 1) {
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                                        }
                                    }
                                },
                                {
                                    view: "button", value: "Apply", click: function () {
                                        $$($this.isKontak ?$this.idKanban:"myBoard").filter();
                                        var values = $$($this.isKontak ? $this.idKanban + "filterFormd" : "filterFormd").getValues();
                                        //var text = values.text;
                                        //$this.filterRequest.Tags = values.tags;
                                        $this.filterRequest.Status = values.status;
                                        $this.filterRequest.Color = values.color;
                                        //var assign = values.assign;
                                        //var color = values.color;

                                        //ftext = values.text;
                                        //ftags = values.tags;
                                        //fstatus = values.status;
                                        //fassign = values.assign;
                                        //fcolor = values.color;
                                        $this.handlerFilter();
                                        //if (text != "") {
                                        //    $$(this.isKontak ?this.idKanban:"myBoard").filter("#text#", text);
                                        //}
                                        //if (color != "") {
                                        //    var arrClr = color.split(",");
                                        //    $$(this.isKontak ?this.idKanban:"myBoard").filter(function (obj) {
                                        //        return arrClr.some(i => i.includes(obj.color));
                                        //    });
                                        //}
                                        //if (assign != "") {
                                        //    var arrAsgn = assign.split(",");
                                        //    $$(this.isKontak ?this.idKanban:"myBoard").filter(function (obj) {
                                        //        return arrAsgn.some(i => i.includes(obj.user_id));
                                        //    });
                                        //}
                                        this.getTopParentView().hide();
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-listd' : 'btn-listd').getValue() == 1) {
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban:"myBoard").serialize(), "json");
                                        }
                                    }
                                }
                            ],
                        }
                    ],
                    elementsConfig: {
                        labelPosition: "top",
                    }
                }
            });
        }

        handlerFilter() {
            var $this = this;
            //if (this.filterRequest.Status != "") {
            //    var arrSts = this.filterRequest.Status.split(",");
            //    $$(this.isKontak ?this.idKanban:"myBoard").filter(function (obj) {
            //        return arrSts.some(i => i.includes(obj.$list));
            //    });
            //}
            $$($this.isKontak ? $this.idKanban:"myBoard").filter(function (obj) {
                var search = obj.text.toLowerCase().includes($this.filterRequest.Search.toLowerCase());
                //var tags = true;
                var status = true;
                var color = true;
                //if (!Q.isEmptyOrNull($this.filterRequest.Tags)) {
                //    var arrTags = $this.filterRequest.Tags.split(",");
                //    tags = arrTags.some(i => obj.tags.includes(i))
                //}
                if (!Q.isEmptyOrNull($this.filterRequest.Status)) {
                    var arrSts = $this.filterRequest.Status.split(",");
                    status = arrSts.some((i:any) => i.includes(obj.$list));
                }
                if (!Q.isEmptyOrNull($this.filterRequest.Color)) {
                    var arrColor = $this.filterRequest.Color.split(",");
                    color = arrColor.some((i:any) => i.includes(obj.priority));
                }
                return search && status && color;
            });
            //$$(this.isKontak ?this.idKanban:"myBoard").filter("#text#", this.filterRequest.Search);
        }

        showForm(winId, node) {
            $$(winId).getBody().clear();
            $$(winId).show(node);
            $$(winId).getBody().focus();
        }

        dialogClose() {
            if (this.isKontak) {
                super.dialogClose();
            }
        }

        private _ContactId: number=null;

        get contactId() {
            return this._ContactId;
        }
        set contactId(value: number) {
            if (this._ContactId !== value) {
                this._ContactId = value;
                this.listBoard();
            }
        }

        private _GroupId: number=null;

        get groupId() {
            return this._GroupId;
        }
        set groupId(value: number) {
            if (this._GroupId !== value) {
                this._GroupId = value;
                this.listBoard();
            }
        }

        private _Dealsid: number=null;

        get dealsId() {
            return this._Dealsid;
        }
        set dealsId(value: number) {
            if (this._Dealsid !== value) {
                this._Dealsid = value;
                this.listBoard();
            }
        }
        formatAutoNumeric(value) {
            var input = $(`<input type="text">`);

            var optionAuto = $.cookie("formatnumber");
            if (optionAuto == null) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }

            if (value == "" || value == null) {
                return "0";
            } else {
                input.autoNumeric('set', value);
                return input.val();
            }
        }
        
        sortableStatus() {
            var $this = this;
            $this.element.find("#edit-board-list").sortable({
                handle: ".handle",
                containment: 'parent',
                cursor: "move",
                update: function (event, ui) {
                }
            });
        }

        boardEditAmbilValue() {
            var $this = this;
            var ab = $this.arrBoard.find(obj => obj.id == $this.boardActive)
            $$($this.isKontak ? $this.idKanban + "menuFormd":"menuFormd").setValues({
                id: ab.id,
                name: ab.value,
                desc: ab.desc
            })
            $this.element.find('#edit-board-list').text('');
            $this.element.find('#edit-board-title').val(ab.value);
            $this.element.find('#edit-board-description').val(ab.desc);
            $this.arrPipelineTypes.forEach(e => {
                var id = e.Id;
                var nama = e.Name;
                var elList = $('<li class="ori lkcard lkcard-bordered mt-0 mb-1" data-id="' + id + '"><div class="row no-gutters">' +
                    '<div class="col-10"><input class="w-80 h-100 no-bdr lkform-control" value="' + nama + '" type="text"></div>' +
                    '<div class="col-2 text-right py-1"><a href="#" class="clearlist mr-2"><i class="fa fa-times"></i></a><span class="handle mr-2" style="cursor: move;"><i class="fa fa-grip-vertical"></i></span></div></div>' +
                    '</li>');
                elList.find("a.clearlist").on('click', function (e) {
                    e.preventDefault();
                    elList.addClass("terhapus");
                    elList.hide();
                });
                $this.element.find('#edit-board-list').append(elList);
            });

            $this.sortableStatus();
            //$('#edit-board-list a.clearlist').unbind("click");
            //$('#edit-board-list a.clearlist')
        }

        constructor(container?: JQuery,calenderEl?: JQuery, isKontak: boolean = false) {
            super(container);
            var $this = this;
            if (container) {
                this.idKanban = container.attr("id");
            }
            this.isKontak = isKontak;
            this.initKanban();
            if (!isKontak) {
                this.listBoard();
            }
            webix.event(window, "resize", () => { this.kanbanLayout.adjust(); });
            $$(this.isKontak ?this.idKanban+"selectBoard":"selectBoard").attachEvent("onChange", (newValue, oldValue, config) => {
                if (newValue != "") {
                    this.loadData(newValue, this._ContactId, this._Dealsid, this._GroupId);
                    localStorage.setItem(this.isKontak ?this.idKanban+"lastOpenedProject":"lastOpenedProject", newValue);
                }
            });
            $(".s-sidebar-band-link.s-sidebar-pane-toggle-link").on("click", () => {
                setTimeout(() => {
                    this.kanbanLayout.adjust();
                },500)
            })

            this.element.find('#board-list').lkselect2({
                tags: true,
                tokenSeparators: [','],
                createTag: function (params) {
                    var term = $.trim(params.term);

                    if (term === '') {
                        return null;
                    }

                    return {
                        id: term,
                        text: term,
                        newTag: true // add additional parameters
                    }
                },
                insertTag: function (data, tag) {
                    // Insert the tag at the end of the results
                    data.push(tag);
                }
            });
            this.element.find("#board-list").on("lkselect2:select", function (evt) {
                var element = evt.params.data.element;
                var $element = $(element);

                $element.detach();
                $(this).append($element);
                $(this).trigger("change");
            });

            this.element.find('#addBoard').click(function () {
                var blist = $this.element.find('#board-list').val();
                if (!Q.isEmptyOrNull($this.element.find('#board-title').val())) {

                    DealpipelinesService.Create(
                        {
                            Entity: {
                                Nm: $('#board-title').val(),
                                //GrpId: ,
                                AliasId: 1,
                                PrivacyVisibility: "portal",
                                RatingStatus: "stage",
                                RatingStatusPeriod: "monthly",
                                Description: $('#board-description').val()
                            }
                        },
                        res => {
                            if (blist.length == 0) {
                                $this.listBoard();
                            }
                            blist.forEach(function (e, eix) {

                                var idList;
                                idList = "_" + e.replaceAll(" ", "_");
                                DealpipelinetypesService.Create({
                                    Entity: {
                                        Name: e,
                                        LegendBlocked: "Blocked",
                                        LegendDone: "Ready",
                                        LegendNormal: "In Progress",
                                        project_id: res.EntityId,
                                        stgindex: eix,
                                        CreateDate: new Date().toISOString()

                                    }
                                }, res => {
                                    if (blist.length == eix + 1) {
                                        $this.listBoard();
                                    }
                                });
                            });
                        }
                    )
                    $this.element.find('#addBoardPopup').lkmodal('hide');
                    $this.element.find('#board-title').val('');
                    $this.element.find('#board-description').val('');
                    $this.element.find('#board-list').val(null).trigger('change');
                } else {
                    Q.notifyError("Name can't be null");
                }
            });
            $this.element.find('#addBoardPopup').on('show.bs.lkmodal', function (e) {
                $this.element.find('#board-title').val('');
                $this.element.find('#board-description').val('');
                $this.element.find('#board-list').val(["New", "Qualified", "Advance", "Payment In Process", "Won", "Lost"]).trigger("change");
                ["New", "Qualified", "Advance", "Payment In Process", "Won", "Lost"].forEach(e => {
                    var $element = $this.element.find("#board-list option").filter(function () {
                        return $(this).text() == e;
                    }).first();
                    $element.detach();
                    $this.element.find('#board-list').append($element);
                    $this.element.find('#board-list').trigger("change");
                })
            });
            $this.element.find('#edit-board-nama-list').keypress(function (e) {
                var ab = $this.element.find('#edit-board-nama-list').val();
                var id = '_' + ab.replaceAll(' ', '_');
                if (e.which == 13) {
                    if ($this.HeaderList[ab] == undefined) {
                        var elList = $('<li class="baru lkcard lkcard-bordered mt-0 mb-1"><div class="row no-gutters">' +
                            '<div class="col-10"><input class="w-80 h-100 no-bdr lkform-control" id="' + id + '" value="' + ab + '" type="text"></div>' +
                            '<div class="col-2 text-right py-1"><a href="#" class="clearlist mr-2"><i class="fa fa-times"></i></a><span class="handle mr-2" style="cursor: move;"><i class="fa fa-grip-vertical"></i></span></div></div>' +
                            '</li>');
                        elList.find("a.clearlist").on('click', function (e) {
                            e.preventDefault();
                            $this.boardListHapus.push(elList.index());
                            elList.hide();
                        });
                        $this.element.find('#edit-board-list').append(elList);
                        $this.element.find('#edit-board-nama-list').val('');
                        $this.HeaderList[ab] = 0;
                    } else {
                        Q.notifyError(`Deal stage with name ${ab} is already exist`);
                    }
                    //$('#edit-board-list a.clearlist').unbind("click");
                }
            });
            var namaBoardEdit = [];
            $this.element.find('#editBoard').click(function () {
                var title = $this.element.find('#edit-board-title').val();
                var desc = $this.element.find('#edit-board-description').val();
                var arrStatusSave = [];
                var arrStatusDel = [];

                if (!Q.isEmptyOrNull($this.element.find('#edit-board-title').val())) {
                    $this.element.find("#edit-board-list li:visible").each(function (index) {
                        var dataId = $(this).data("id");
                        var text = $(this).find("input").val();
                        if (dataId != undefined) {
                            $this.arrPipelineTypes.forEach(plt => {
                                if (dataId == plt.Id) {
                                    plt.stgindex = index;
                                    plt.Name = text;
                                    arrStatusSave.push(plt);
                                }
                            });
                        } else {
                            arrStatusSave.push({
                                Name: text,
                                stgindex: index
                            });
                        }
                    });
                    $this.element.find('#edit-board-list li[style="display: none;"]').each(function (index) {
                        var dataId = $(this).data("id");
                        var text = $(this).find("input").val();
                        if (dataId != undefined) {
                            $this.arrPipelineTypes.forEach(plt => {
                                if (dataId == plt.Id) {
                                    plt.stgindex = index;
                                    arrStatusDel.push(plt);
                                }
                            });
                        }
                    });
                    DealpipelinesService.Update(
                        {
                            EntityId: $this.boardActive,
                            Entity: {
                                Nm: title,
                                Description: desc,
                                TypeList: arrStatusSave,
                                TypeListDel: arrStatusDel
                            }
                        },
                        res => {
                            $this.listBoard();
                            $this.element.find('#editBoardPopup').lkmodal('hide');
                        }
                    )
                } else {
                    Q.notifyError("Name can't be null");
                }
            });
        }

        getTemplate() {
            return `<div id="kanban"></div>
                    <div class="s-Form d-none">
                        <form id="~_Form" action="">
                            <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                <div id="~_PropertyGrid"></div>
                                <div class="clear"></div>
                            </div>
                        </form>
                    </div>
                    <div id="~_Toolbar"  class="s-DialogToolbar mt-3 p-toolbar d-none">
                    </div>

        <div class="lkmodal lkfade" id="addBoardPopup">
            <div class="lkmodal-dialog lkmodal-md" role="document">
                <div class="lkmodal-content">
                    <div class="lkmodal-lkheader">
                        <h5 class="lkmodal-title" data-i18n="Add Project">Add Pipeline</h5>
                        <a href="#" class="close" data-dismiss="lkmodal" aria-label="Close">
                            <em class="icon fa fa-close"></em>
                        </a>
                    </div>
                    <div class="lkmodal-body pb-0">
                        <form action="#" id="addBoardForm" class="form-validate is-alter">
                            <div class="row gx-4 gy-3">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="board-title" data-i18n="Name">Name</label>
                                        <div class="lkform-control-wrap">
                                            <input type="text" class="lkform-control" id="board-title" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="board-description" data-i18n="Description">Description</label>
                                        <div class="lkform-control-wrap">
                                            <textarea class="lkform-control" style="width:100%;resize: none;overflow: hidden;min-height: 37px;padding:7px 16px;" id="board-description"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label"><span data-i18n="Lists">Stage</span> <span class="text-danger small" data-i18n="*type list name and press Enter to add new list">*type stage name and press enter to add new stage</span></label>
                                        <div class="lkform-control-wrap">
                                            <select id="board-list" class="BoardListMultiple" multiple="multiple">
                                                <option>New</option>
                                                <option>Qualified</option>
                                                <option>Advance</option>
                                                <option>Payment In Process</option>
                                                <option>Won</option>
                                                <option>Lost</option>

                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="lkmodal-footer-stretch p-3">
                        <div class="d-flex justify-content-end gx-4 mt-1">
                            <div class="pr-1">
                                <button id="addBoard" type="submit" class="lkbtn lkbtn-primary" data-i18n="Save">Save</button>
                            </div>
                            <div>
                                <button id="resetBoard" data-dismiss="lkmodal" class="lkbtn lkbtn-danger lkbtn-dim" data-i18n="Cancel">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                    <div class="lkmodal lkfade" id="editBoardPopup">
            <div class="lkmodal-dialog lkmodal-md" role="document">
                <div class="lkmodal-content">
                    <div class="lkmodal-lkheader">
                        <h5 class="lkmodal-title" data-i18n="Edit Project">Edit Pipeline</h5>
                        <a href="#" class="close" data-dismiss="lkmodal" aria-label="Close">
                            <em class="icon fa fa-close"></em>
                        </a>
                    </div>
                    <div class="lkmodal-body pb-0">
                        <form action="#" id="editBoardForm" class="form-validate is-alter">
                            <div class="row gx-4 gy-3">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="edit-board-title" data-i18n="Name">Name</label>
                                        <div class="lkform-control-wrap">
                                            <input type="text" class="lkform-control" id="edit-board-title" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="edit-board-description" data-i18n="Description">Description</label>
                                        <div class="lkform-control-wrap">
                                            <textarea class="lkform-control" style="width:100%;resize: none;overflow: hidden;min-height: 37px;padding:7px 16px;" id="edit-board-description"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div style="padding-top: 8px;">
                            <label for="board-list" class="form-label"><span data-i18n="Lists">Stage</span> <span class="small text-danger" data-i18n="*type list name and press Enter to add new list">*type stage name and press enter to add new stage</span></label>
                            <div class="form-group">
                                <div class="lkform-control-wrap">
                                    <input type="text" class="lkform-control" id="edit-board-nama-list" required>
                                </div>
                            </div>
                            <div style="height: 150px;" data-simplebar>
                                <ul id="edit-board-list">
                                    <li>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="lkmodal-footer-stretch p-3">
                        <div class="d-flex justify-content-end gx-4 mt-1">
                            <div class="pr-1">
                                <button id="editBoard" type="submit" class="lkbtn lkbtn-primary" data-i18n="Save">Save</button>
                            </div>
                            <div>
                                <button id="resetBoard" data-dismiss="lkmodal" class="lkbtn lkbtn-danger lkbtn-dim" data-i18n="Cancel">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
        }

        protected updateInterface() {
            super.updateInterface();
        }

        protected updateTitle() {
            this.dialogTitle = "Deals";
        }

        private WARNING_THRESHOLD = 5;
        private ALERT_THRESHOLD = 3;
        private TIME_LIMIT = 10;
        private timeLeft = this.TIME_LIMIT;
        private timePassed = 0;
        private timerInterval = null;
        private refreshInterval = null;
        private timerActive = false;
        private COLOR_CODES = {
            info: {
                color: "green"
            },
            warning: {
                color: "orange",
                threshold: this.WARNING_THRESHOLD
            },
            alert: {
                color: "red",
                threshold: this.ALERT_THRESHOLD
            }
        };
        formatTime(time) {
            const minutes = Math.floor(time / 60);
            let seconds = time % 60 as any;

            if (seconds < 10) {
                seconds = `0${seconds}`;
            }
            if (seconds == 0) {
                seconds = `...`;
            }

            return `${seconds}`;
        }
        calculateTimeFraction() {
            const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
            return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
        } onTimesUp(e, h = null) {
            clearInterval(this.timerInterval);
            if (this.refreshInterval != null) {
                clearInterval(this.refreshInterval);
            }
            if (h != "...") {
                e.html("<i class=\"fa fa-stopwatch text-blue\"></i>");
                this.timerActive = false;
            } else {
                e.html(h);
                this.timerActive = true;
            }
            this.WARNING_THRESHOLD = 5;
            this.ALERT_THRESHOLD = 3;
            this.TIME_LIMIT = 10;
            this.timePassed = 0;
            this.timeLeft = 10;
            this.timerInterval = null;
            this.refreshInterval = null;
        }
        setRemainingPathColor(timeLeft, e) {
            const { alert, warning, info } = this.COLOR_CODES;
            if (timeLeft <= alert.threshold) {
                e.removeClass(warning.color);
                e.addClass(alert.color);
            } else if (timeLeft <= warning.threshold) {
                e.removeClass(info.color);
                e.addClass(warning.color);
            } else if (timeLeft >= warning.threshold) {
                e.removeClass(alert.color);
                e.addClass(info.color);
            }
        }
        startTimer(e) {
            this.timerActive = true;
            this.refreshInterval = setInterval(() => {
                //refresh();
                //setYearCampaign(ThisYear)
                this.loadData(this.boardActive, this._ContactId, this._Dealsid, this._GroupId);
            }, 10000);
            e.removeClass(this.COLOR_CODES.info.color);
            e.removeClass(this.COLOR_CODES.alert.color);
            e.removeClass(this.COLOR_CODES.warning.color);
            e.addClass(this.COLOR_CODES.info.color);
            this.timerInterval = setInterval(() => {
                this.timePassed = this.timePassed += 1;
                this.timeLeft = this.TIME_LIMIT - this.timePassed;
                e.text(this.formatTime(
                    this.timeLeft
                ));
                this.setRemainingPathColor(this.timeLeft, e);

                if (this.timeLeft === 0) {
                    this.WARNING_THRESHOLD = 5;
                    this.ALERT_THRESHOLD = 3;
                    this.TIME_LIMIT = 10;
                    this.timePassed = 0;
                    this.timeLeft = 10;
                }
            }, 1000);
        }
        dialogOpen() {
            super.dialogOpen();

            this.element.children("div.panel-titlebar").find("button.panel-titlebar-close").remove();
            this.element.children("div.panel-titlebar").append(`
        <div style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:auto;" class="btn btn-icon btn-sm p-0 ml-2">
            <div class="tool-button btn-autorefresh icon-tool-button btn-auto-refresh" title="Auto Refresh in 10 seconds">
                <div class="button-outer">
                    <span class="button-inner green">
                        <i class="fa fa-stopwatch text-blue"></i>
                    </span>
                </div>
            </div>
        </div><a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm btn-panduan p-0 ml-1 float-right" target="_blank" href="/panduan/absensidialog">
                <div class="tool-button icon-tool-button py-1" title="Panduan">
                    <div class="button-outer">
                        <span class="button-inner green">
                            <i class="fa fa-play-circle text-blue"></i>
                        </span>
                    </div>
                </div>
            </a>`);
            this.element.find(".btn-auto-refresh").on('click', (e)=> {
                if (!this.timerActive) {
                    if ($(e.currentTarget).hasClass("tool-button")) {
                        $(e.currentTarget).find(".button-inner").text("10");
                        this.startTimer($(e.currentTarget).find(".button-inner"));
                    } else {
                        $(e.currentTarget).parents(".tool-button").find(".button-inner").text("10")
                        this.startTimer($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                    }
                } else {
                    if ($(e.currentTarget).hasClass("tool-button")) {
                        this.onTimesUp($(e.currentTarget).find(".button-inner"));

                    } else {
                        this.onTimesUp($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                    }
                }
            });
            Q.Router.replace("");

            //setTimeout(() => {
            //}, 400);

            this.kanbanLayout.adjust();
        }
    }
}